import { useRef } from 'react';

export const useNonce = () =>
  useRef(document.querySelector<HTMLMetaElement>('meta[property=csp-nonce]')).current?.content;
